<template>
  <div class="nc-radio-group" :class="{ 'nc-radio-group--horizontal': horizontal }">
    <label v-if="label" class="nc-radio-group__label">{{ label }}</label>
    <div class="nc-radio-group__options">
      <label
        v-for="option in options"
        :key="option.value"
        class="nc-radio"
        :class="{ 'nc-radio--disabled': disabled }"
        @click.prevent="select(option.value)"
      >
        <span class="nc-radio__circle" :class="{ 'nc-radio__circle--selected': modelValue === option.value }">
          <span v-if="modelValue === option.value" class="nc-radio__dot" />
        </span>
        <span class="nc-radio__text">{{ option.label }}</span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NcRadio',
  props: {
    modelValue: { type: [String, Number, Boolean], default: null },
    options: { type: Array, default: () => [] },
    label: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    horizontal: { type: Boolean, default: false },
  },
  emits: ['update:modelValue'],
  methods: {
    select(value) {
      if (!this.disabled) {
        this.$emit('update:modelValue', value);
      }
    },
  },
};
</script>

<style scoped>
.nc-radio-group__label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: var(--nc-text-secondary, #92949c);
  margin-bottom: 8px;
}
.nc-radio-group__options {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.nc-radio-group--horizontal .nc-radio-group__options {
  flex-direction: row;
  flex-wrap: wrap;
  gap: 12px;
}
.nc-radio {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  padding: 8px 4px;
  -webkit-user-select: none;
  user-select: none;
  position: relative;
}
/* Tikgebied minimaal 44px (iOS HIG / WCAG 2.5.5) zonder de layout te wijzigen. */
.nc-radio::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  min-width: 44px;
  min-height: 44px;
}
.nc-radio--disabled { opacity: 0.4; pointer-events: none; }
.nc-radio__circle {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid var(--nc-border, #d0d5dd);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: border-color 0.15s ease;
}
.nc-radio__circle--selected {
  border-color: var(--nc-color-primary, #14b69a);
}
.nc-radio__dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--nc-color-primary, #14b69a);
}
.nc-radio__text {
  font-size: var(--nc-font-size-sm, 14px);
  color: var(--nc-text, #1a1a2e);
}
</style>
